import createStore from "@Stores/base-factories"
import { hookPageList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('reward-step')
  .extendHookCollectionsFactory('reward-steps')
  .extend(hookPageList('pages'))
  .factory()

export {
  Provider as RewardStepsProvider,
  useStore as useRewardStepsStore,
}
